import React from 'react'
import './Sub.css';
import './Sub.css';
import MasonryImageList from './ImageList';

function Gallery({ closeGallery, GalleryRef }) {
  return (
    <div className='Gallery-main' ref={GalleryRef}>
      <div className='Gallery'>
        <div className='close-icon-container' onClick={closeGallery} >
        </div>
        <div className='Gallery-images'>

          <MasonryImageList />

        </div>
      </div>

    </div>
  )
}

export default Gallery
